"use strict";

exports.__esModule = true;
exports.TimeContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides information about the plant time to consumers.
 * @component
 */
var TimeContext = exports.TimeContext = (0, _Utils.createEnhancedContext)({
  propName: "time"
});